// Inline SVG icons — no icon font, no network request, tree-shakeable.
import React from "react";

const Svg = ({ children, size = 18, stroke = 1.7, fill = "none", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={fill === "none" ? "currentColor" : "none"}
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const GitHub = (p) => (
  <Svg fill="currentColor" {...p}>
    <path d="M12 2C6.48 2 2 6.58 2 12.25c0 4.53 2.87 8.37 6.84 9.73.5.1.68-.22.68-.5l-.01-1.72c-2.78.62-3.37-1.37-3.37-1.37-.46-1.18-1.11-1.5-1.11-1.5-.91-.64.07-.62.07-.62 1 .07 1.53 1.06 1.53 1.06.89 1.57 2.34 1.12 2.91.86.09-.66.35-1.12.63-1.38-2.22-.26-4.56-1.14-4.56-5.06 0-1.12.39-2.03 1.03-2.75-.1-.26-.45-1.3.1-2.71 0 0 .84-.28 2.75 1.05a9.28 9.28 0 0 1 5 0c1.91-1.33 2.75-1.05 2.75-1.05.55 1.41.2 2.45.1 2.71.64.72 1.03 1.63 1.03 2.75 0 3.93-2.35 4.79-4.58 5.05.36.32.68.94.68 1.9l-.01 2.82c0 .28.18.6.69.5A10.26 10.26 0 0 0 22 12.25C22 6.58 17.52 2 12 2Z" />
  </Svg>
);

export const LinkedIn = (p) => (
  <Svg fill="currentColor" {...p}>
    <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.37-1.85c3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13Zm1.78 13.02H3.55V9h3.57v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z" />
  </Svg>
);

export const Instagram = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.6" cy="6.4" r="1.1" fill="currentColor" stroke="none" />
  </Svg>
);

export const Mail = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="4.5" width="19" height="15" rx="3" />
    <path d="m3.5 7 7.4 5.2a2 2 0 0 0 2.2 0L20.5 7" />
  </Svg>
);

export const ArrowRight = (p) => (
  <Svg {...p}><path d="M4 12h15m0 0-6-6m6 6-6 6" /></Svg>
);

export const ArrowUpRight = (p) => (
  <Svg {...p}><path d="M7 17 17 7m0 0H8m9 0v9" /></Svg>
);

export const ArrowUp = (p) => (
  <Svg {...p}><path d="M12 20V4m0 0-6 6m6-6 6 6" /></Svg>
);

export const ChevronDown = (p) => (
  <Svg {...p}><path d="m6 9 6 6 6-6" /></Svg>
);

export const Sun = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Svg>
);

export const Moon = (p) => (
  <Svg {...p}><path d="M20.5 14.3A8.5 8.5 0 0 1 9.7 3.5a8.5 8.5 0 1 0 10.8 10.8Z" /></Svg>
);

export const Search = (p) => (
  <Svg {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.6-3.6" /></Svg>
);

export const Command = (p) => (
  <Svg {...p}>
    <path d="M9 6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6Z" />
  </Svg>
);

export const Download = (p) => (
  <Svg {...p}><path d="M12 3v12m0 0 4.5-4.5M12 15l-4.5-4.5M4 18v1.5A1.5 1.5 0 0 0 5.5 21h13a1.5 1.5 0 0 0 1.5-1.5V18" /></Svg>
);

export const Home = (p) => (
  <Svg {...p}><path d="m3.5 10.5 8-6.6a1 1 0 0 1 1.3 0l7.7 6.6M5.5 9.6V19a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5V9.6" /></Svg>
);

export const Briefcase = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="7.5" width="19" height="12.5" rx="2.5" />
    <path d="M8.5 7.5V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.5M2.5 12.5h19" />
  </Svg>
);

export const Folder = (p) => (
  <Svg {...p}><path d="M3 7.5A2 2 0 0 1 5 5.5h3.6a2 2 0 0 1 1.5.7l1 1.2H19a2 2 0 0 1 2 2v7.1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.5Z" /></Svg>
);

export const Message = (p) => (
  <Svg {...p}><path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-5.4A8 8 0 0 1 11 4h2a8 8 0 0 1 8 8Z" /></Svg>
);

export const Star = (p) => (
  <Svg {...p}><path d="m12 3.6 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.8l5.9-.8L12 3.6Z" /></Svg>
);

export const Award = (p) => (
  <Svg {...p}><circle cx="12" cy="9" r="5.5" /><path d="m8.5 13.8-1.3 6.7 4.8-2.6 4.8 2.6-1.3-6.7" /></Svg>
);

export const MapPin = (p) => (
  <Svg {...p}><path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11Z" /><circle cx="12" cy="10" r="2.6" /></Svg>
);

export const Terminal = (p) => (
  <Svg {...p}><path d="m5 8 4 4-4 4m6 1h7" /><rect x="2.5" y="3.5" width="19" height="17" rx="3" /></Svg>
);

export const Copy = (p) => (
  <Svg {...p}><rect x="9" y="9" width="12" height="12" rx="2.5" /><path d="M6 15H4.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V6" /></Svg>
);

export const Check = (p) => (
  <Svg {...p}><path d="m4.5 12.5 5 5 10-11" /></Svg>
);

export const Menu = (p) => (
  <Svg {...p}><path d="M4 7h16M4 12h16M4 17h16" /></Svg>
);

export const X = (p) => (
  <Svg {...p}><path d="m6 6 12 12M18 6 6 18" /></Svg>
);

export const Code = (p) => (
  <Svg {...p}><path d="m8 7-5 5 5 5m8-10 5 5-5 5M14 4l-4 16" /></Svg>
);

export const Layers = (p) => (
  <Svg {...p}><path d="m12 3 9 5-9 5-9-5 9-5Zm9 9-9 5-9-5m18 4-9 5-9-5" /></Svg>
);

export const Cloud = (p) => (
  <Svg {...p}><path d="M17.5 19a4.5 4.5 0 0 0 .3-9 6 6 0 0 0-11.6 1.6A3.7 3.7 0 0 0 7 19h10.5Z" /></Svg>
);

export const Graduation = (p) => (
  <Svg {...p}><path d="m12 4 10 4.5-10 4.5L2 8.5 12 4Zm-6 6.6v4.6c0 1.6 2.7 2.9 6 2.9s6-1.3 6-2.9v-4.6" /></Svg>
);

export const SOCIAL_ICONS = {
  github: GitHub,
  linkedin: LinkedIn,
  instagram: Instagram,
  mail: Mail,
};
